import * as React from 'react';

import PhotoGallery from '../../../common/components/photo_gallery/photo_gallery';

import { IPhoto } from '../../../../api/offer';

const styles = require('./serp_photo_gallery.css');

interface ISerpPhotoGalleryProps {
  photos: IPhoto[];
}

interface ISerpPhotoGalleryState {
  currentIndex: number;
}

class SerpPhotoGallery extends React.Component<ISerpPhotoGalleryProps, ISerpPhotoGalleryState> {
  private gallery: PhotoGallery;

  public constructor(props: ISerpPhotoGalleryProps){
    super(props);

    this.state = {
      currentIndex: 0,
    }
  }

  public render() {
    const { photos } = this.props;
    return (
      <div className={styles['proxy']}>
        <PhotoGallery
          ref={ref => this.gallery = ref}
          slides={photos}
          height={246}
          allowFullscreen={false}
          thumbnails={{enabled: false}}
          fit="cover"
          onSlideChange={(index) => this.onSlideChange(index)}
        />
        {photos.length > 1 && <div className={`${styles['overlay']} cf-bsc-li-photos-overlay`}>
          {this.state.currentIndex} из {photos.length}
        </div>}
      </div>
    );
  }

  private onSlideChange(index: number) {
    this.setState({
      currentIndex: index + 1,
    });
  }
}
export default SerpPhotoGallery;



// WEBPACK FOOTER //
// ./src/bundles/common/components/serp_photo_gallery/serp_photo_gallery.tsx